<script setup lang="ts">
/**
 * NavAiPromo — 커머스 모바일 메뉴(AppHeader 드로어) 하단 "AI 입시분석" 홍보 카드.
 * 메뉴 라벨("내 성적 분석")은 학생 눈높이 용어로 유지하고, 랜딩 AI 섹션과 같은 색(`--hero-ai-*`)·같은 카피
 * (`AI_WORKSPACE_BANNER`)로 "같은 기능"임을 인지시킨다. 목적지는 `brand.crossLinks.analysis`(두 축 교차 진입 SSoT),
 * 계측은 AiWorkspaceCta 와 같은 GA4 `analysis_entry_click{placement:'mobile_menu'}`.
 */
import { ArrowRight } from 'lucide-vue-next';
import { RouterLink } from 'vue-router';

import { brand } from '#/config/brand';
import { AI_WORKSPACE_BANNER as B } from '#/data/aiWorkspaceBanner';
import { trackAnalysisEntry } from '#/lib/analytics';

const emit = defineEmits<{ navigate: [] }>();

function onClick(): void {
  trackAnalysisEntry('mobile_menu');
  emit('navigate');
}
</script>

<template>
  <RouterLink :to="brand.crossLinks.analysis" class="nap" @click="onClick">
    <span class="nap-eyebrow">{{ B.eyebrow }}</span>
    <span class="nap-title">{{ B.headline[0] }}<br />{{ B.headline[1] }}</span>
    <span class="nap-cta">
      {{ B.cta }}
      <ArrowRight :size="15" :stroke-width="2.4" />
    </span>
  </RouterLink>
</template>

<style scoped>
.nap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px;
  border-radius: 16px;
  background: var(--hero-ai-bg);
}

.nap-eyebrow {
  font-size: 12px;
  font-weight: 700;
  color: var(--hero-ai-green);
}

.nap-title {
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.02em;
  color: var(--hero-ai-ink);
}

.nap-cta {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  margin-top: 4px;
  font-size: 13.5px;
  font-weight: 800;
  color: var(--hero-ai-green);
}

.nap:focus-visible {
  outline: 2px solid var(--hero-ai-green);
  outline-offset: 2px;
}
</style>
